/* eslint-disable indent */
// 默认值
import {TOKEN_KEY} from '@/utils/const'
import {commAction} from '../action'
import defaultState, {CommDefaultStateType} from '../state/comm'
import Cookies from 'js-cookie'

type CommActionType = keyof typeof commAction

export type CommStateType = {
	comm: CommDefaultStateType
}

export default function commReducer(state = defaultState, action: {type: CommActionType; payload: any}) {
	switch (action.type) {
		case commAction.SET_TOKEN:
			if (action.payload) {
				Cookies.set(TOKEN_KEY, action.payload)
			} else {
				Cookies.remove(TOKEN_KEY)
			}
			return {
				...state,
				token: action.payload
			}
		case commAction.UPDATE_APP_CONF_MODULE:
			return {
				...state,
				appModule: action.payload
			}
		case commAction.RESET_COMM_STORE:
			return defaultState
		case commAction.PERIOD_Id:
			return {
				...state,
				periodId: action.payload
			}
		default:
			return state
	}
}
